export default function Footer() {
  return (
    <div className="mt-4 pt-4 text-sm text-white bg-blue-500 pb-4">
      <div className="mx-auto max-w-[1200px] px-4 flex flex-col md:flex-row justify-between gap-8 text-12 pb-4">
        {/* Seção 1 */}
        <div className="w-full md:w-1/3">
          <h2 className="text-xl font-medium">Eyazs Imperium</h2>
          <br />
          <span className="block">
            A Eyazs imperium é uma empresa moçambicana de direitos legais, jovem
            e dinâmica. Com uma abordagem ativa e proativa, estamos
            comprometidos em oferecer os melhores serviços, sempre com foco na
            excelência.
          </span>
        </div>

        {/* Seção 2 */}
        <div className="w-full md:w-1/3">
          <h2 className="text-xl font-medium">Serviços Disponíveis</h2>
          <br />
          <div className="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className=" group-hover:text-blue-500 size-4 text-white"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
              />
            </svg>
            <span className="ml-2">Planos de internet</span>
          </div>
          <div className="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-4 text-white group-hover:text-blue-500"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
              />
            </svg>
            <span className="ml-2">Efetuar Pagamentos</span>
          </div>
          <div className="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-4 text-white group-hover:text-blue-500"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
              />
            </svg>
            <span className="ml-2">Histórico de Pagamentos</span>
          </div>
          <div className="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-4 text-white group-hover:text-blue-500"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
              />
            </svg>
            <span className="ml-2">Minha Conta</span>
          </div>
        </div>

        {/* Seção 3 */}
        <div className="w-full md:w-1/3">
          <h2 className="text-xl font-medium">Entre em Contato</h2>
          <br />
          <div className="flex items-start">
            <img width={15} src="../../images/globo.png" alt="" />
            <span className="ml-2">
              Malhangalene-Ilha Largo de, Maputo-Mocamnique, Maputo 1103
            </span>
          </div>
          <div className="flex items-center">
            <img width={15} src="../../images/telefone.png" alt="" />
            <span className="ml-2">
              Assistência Administrativa: +258 87 381 0871
            </span>
          </div>
          <div className="flex items-center">
            <img width={15} src="../../images/telefone.png" alt="" />
            <span className="ml-2">Assistência Técnica: +258  87 301 1011</span>
          </div>
          <div className="flex items-center">
            <img width={15} src="../../images/whatsapp.png" alt="" />
            <span className="ml-2">Assistência Whatsapp: +258 87 381 0871</span>
          </div>
        </div>
      </div>

      {/* Rodapé Inferior */}
      <div className="flex flex-col items-center justify-center text-center mt-4 px-4">
        <hr className="w-full mb-2 border-gray-200" />
       <span>© {new Date().getFullYear()} EYAZS IMPERIUM. Todos os direitos reservados.</span>
      </div>
    </div>
  );
}
